import {
  trackFTExperimentActionCardsClicked,
  trackInterviewEducationTriggered,
  trackDevelopEducationTriggered,
  trackVideoInterviewEducationTriggered,
  trackLiveInterviewEducationTriggered,
  trackAnalyticsModalTriggered,
} from "./trackingFunctions";

export const triggerAppCuesEvent = (
  eventName,
  eventAttributes,
  fallbackUrl,
  userAccountId,
  fromFreeTrialHomeActionCards = false
) => {
  let timeoutId;

  if (fromFreeTrialHomeActionCards) {
    trackFTExperimentActionCardsClicked(eventName, eventAttributes);
  } else if (eventName === "si_modal") {
    trackInterviewEducationTriggered(eventAttributes?.surface_area);
  } else if (eventName === "develop_modal") {
    trackDevelopEducationTriggered(eventAttributes?.surface_area);
  } else if (eventName === "vi_modal") {
    trackVideoInterviewEducationTriggered(eventAttributes?.surface_area);
  } else if (eventName === "li_modal") {
    trackLiveInterviewEducationTriggered(eventAttributes?.surface_area);
  } else if (eventName === "analytics_modal") {
    trackAnalyticsModalTriggered(eventAttributes?.surface_area);
  }

  const openCaseStudies = () => {
    window.open(fallbackUrl, "_blank", "noopener");
  };

  const handleAppcuesEvent = (e) => {
    if (e === "step_aborted") {
      openCaseStudies();
    }
  };

  if (window.Appcues) {
    const { surface_area } = eventAttributes;

    window.Appcues.identify(userAccountId, {
      merch_surface_area: surface_area,
    });

    window.Appcues.track(eventName, eventAttributes);

    window.Appcues.on("all", (e) => {
      clearTimeout(timeoutId);
      handleAppcuesEvent(e);
    });

    timeoutId = setTimeout(() => {
      openCaseStudies();
    }, 2000);
  } else {
    openCaseStudies();
  }
};

export const getUserType = (
  isFreeTrial,
  isAdoption,
  isAutoRenewalRep,
  fromDevelopMerch = false
) => {
  // userType defaults to upgrade - Subscribers without SI with a regular AM or Subscriber without Develop
  // isAdoption - Subscribers with SI or Develop
  let userType = "upgrade";
  if (isFreeTrial) {
    userType = "ft";
  } else if (!fromDevelopMerch && isAdoption) {
    userType = "adoption";
  } else if (isAutoRenewalRep) {
    userType = "de";
  }

  return userType;
};
